import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_USER,
  GET_USER_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  loggedUser: {},
}

const Login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        loggedUser: action.payload,
      }
      break
    case GET_USER:
      state = {
        ...state,
      }
      break
    case GET_USER_SUCCESS:
      state = {
        ...state,
        loggedUser: action.payload,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Login
